import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai';
import { useEffect, useState } from 'react';
import { type PaginatedMeta } from '../common/types';

interface IProps {
  pageData?: PaginatedMeta;
  handlePageChange?: any;
}

const emptyPageMeta: PaginatedMeta = {
  currentPage: 1,
  perPage: 10,
  totalItemCount: 0,
  pageCount: 1,
  hasPreviousPage: false,
  hasNextPage: false
};

const Pagination: React.FC<IProps> = ({ pageData, handlePageChange }) => {
  const [pageMeta, setPageMeta] = useState<PaginatedMeta>(pageData ?? emptyPageMeta);

  useEffect(() => {
    if (pageData != null) {
      setPageMeta(pageData);
    }
  }, [pageData]);

  const NextPage = (): void => {
    if (pageMeta.hasNextPage) {
      handlePageChange(pageMeta.currentPage + 1);
    }
  };

  const PrevPage = (): void => {
    if (pageMeta.hasPreviousPage) {
      handlePageChange(pageMeta.currentPage - 1);
    }
  };

  return (
    <div className="flex rounded-lg justify-center">
      <button
        disabled={!pageMeta.hasPreviousPage}
        onClick={PrevPage}
        className={`h-12 w-12 border-2 border-r-0 border-gray-400 rounded-l-lg ${
          pageMeta.hasPreviousPage ? 'hover:bg-green-600 hover:text-white' : ''
        }`}
      >
        <AiOutlineLeft className="mx-auto" />
      </button>
      <button className="h-12 w-12 border-2 border-r-0 border-gray-400 hover:bg-green-600 hover:text-white">
        {pageMeta.currentPage}
      </button>
      <button
        onClick={NextPage}
        disabled={!pageMeta.hasNextPage}
        className={`h-12 w-12 border-2 border-gray-400 rounded-r-lg ${
          pageMeta.hasNextPage ? 'hover:bg-green-600 hover:text-white' : ''
        }`}
      >
        <AiOutlineRight className="mx-auto" />
      </button>
    </div>
  );
};

export default Pagination;
